import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { AuthShell, PrimaryButton, inputCls } from "@/components/AuthShell";
import { api } from "@/lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(null);
  const valid = EMAIL_RE.test(email.trim());

  const submit = async (e) => {
    e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    setErr(null);
    try {
      await api("/auth/forgot-password", { method: "POST", auth: false, body: { email: email.trim() } });
      setSent(true);
    } catch (e2) {
      setErr(e2.message || "Something went wrong. Please try again in a minute.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <KeyRound size={28} className="text-[#4CCC06]" />
      <h1 className="mt-3 font-display text-3xl font-extrabold uppercase">Reset your password</h1>
      {sent ? (
        <div data-testid="forgot-sent">
          <p className="mt-3 text-sm leading-6 text-neutral-400">
            If an account exists for <b className="text-white">{email.trim()}</b>, we've emailed a secure link to set a new password. Check your inbox (and spam folder).
          </p>
          <PrimaryButton data-testid="forgot-done" onClick={() => navigate("/")}>BACK TO SIGN IN</PrimaryButton>
        </div>
      ) : (
        <form onSubmit={submit}>
          <p className="mb-5 mt-3 text-sm leading-6 text-neutral-400">Enter the email you use to sign in and we'll send you a link to choose a new password.</p>
          <span className="mb-1.5 block text-[11px] font-bold tracking-[0.2em] text-[#4CCC06]">EMAIL</span>
          <input data-testid="forgot-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          {err && <p data-testid="forgot-error" className="mt-3 text-[13px] text-[#FF3333]">{err}</p>}
          <PrimaryButton type="submit" data-testid="forgot-submit" disabled={!valid || busy}>
            {busy ? <Loader2 className="animate-spin" size={18} /> : "SEND RESET LINK"}
          </PrimaryButton>
        </form>
      )}
    </AuthShell>
  );
}
